module.exports = {
          srcSet: __webpack_public_path__ + "ee9b45fdc31255b321162b1a4ae453e6-4911.png"+" 4911w",
          images:[ {path: __webpack_public_path__ + "ee9b45fdc31255b321162b1a4ae453e6-4911.png",width: 4911,height: 2769}],
          src: __webpack_public_path__ + "ee9b45fdc31255b321162b1a4ae453e6-4911.png",
          toString:function(){return __webpack_public_path__ + "ee9b45fdc31255b321162b1a4ae453e6-4911.png"},
          
          width: 4911,
          height: 2769
        }